import { WandSparkles } from "lucide-react";

import type { CustomComposition } from "../../api/types";
import { ProgressBar } from "../../components/Gauge";
import { Motion } from "../../components/presence";
import { Waiting } from "../../components/Waiting";
import { t } from "../../i18n/i18n";

/** Composition par le modèle en cours (ou interrompue par un redémarrage du serveur : elle reprend d'elle-même à la
 *  lecture suivante de l'avancement). */
export function composingNow(composition: CustomComposition | null | undefined): boolean {
  return composition?.state === "running" || composition?.state === "interrupted";
}

/** Avancement de la composition des quatorze modes d'action par le modèle (registre A137) : « Composition des modes
 *  d'action… 5 sur 14 » (points animés) et sa barre ; chaque ME apparaît en dessous dès qu'il est prêt. */
export function ComposeProgress({ composition }: { composition: CustomComposition }) {
  const resuming = composition.state === "interrupted";
  return (
    <Motion origin="fade" className="space-y-2 rounded-lg border border-line bg-surface px-3 py-3" data-testid="custom-enemy-compose-progress">
      <p className="flex flex-wrap items-center gap-2 text-ui font-medium text-ink">
        <span className="flex size-6 shrink-0 items-center justify-center rounded-md bg-run-soft text-run" aria-hidden>
          <WandSparkles size={14} />
        </span>
        <Waiting>{resuming ? t("Reprise de la composition…") : t("Composition des modes d'action…")}</Waiting>
        <span className="text-ink-muted tabular-nums">{t("{used} sur {max}", { used: composition.done, max: composition.total })}</span>
      </p>
      <ProgressBar value={composition.total ? composition.done / composition.total : 0} tone="run" label={t("Avancement de la composition")} />
      <p className="text-meta leading-snug text-ink-muted">
        {t("Chaque mode d'action apparaît dès qu'il est prêt. Vous pouvez quitter cette page : la composition continue.")}
      </p>
    </Motion>
  );
}
